import { BrowserRouter, Routes, Route } from "react-router-dom";
import WaitlistPage from "./pages/WaitlistPage";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WaitlistPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
